import { render, staticRenderFns } from "./Lostpassword.vue?vue&type=template&id=3c634692&scoped=true"
import script from "./Lostpassword.vue?vue&type=script&lang=js"
export * from "./Lostpassword.vue?vue&type=script&lang=js"
import style0 from "./Lostpassword.vue?vue&type=style&index=0&id=3c634692&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c634692",
  null
  
)

export default component.exports